import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

// Pages load on first visit, so the app starts fast.
const page = <K extends string>(load: () => Promise<Record<K, React.ComponentType>>, name: K) => lazy(() => load().then((m) => ({ default: m[name] })));
const MyLearningPage = page(() => import("./web/MyLearningPage.js"), "MyLearningPage");
const PlayerPage = page(() => import("./web/PlayerPage.js"), "PlayerPage");
const ResultPage = page(() => import("./web/ResultPage.js"), "ResultPage");
const TeamPage = page(() => import("./web/TeamPage.js"), "TeamPage");
const CoursesPage = page(() => import("./web/CoursesPage.js"), "CoursesPage");
const BuilderPage = page(() => import("./web/BuilderPage.js"), "BuilderPage");

export default defineWebModule({
  manifest,
  pages: {
    "": MyLearningPage,
    "/play": PlayerPage,
    "/result": ResultPage,
    "/team": TeamPage,
    "/courses": CoursesPage,
    "/build": BuilderPage,
  },
});
